import { Col, Form, Input, InputNumber, Radio, Row, Select, Space, Switch } from 'antd';
import React, { useContext, useEffect, useRef, useState } from 'react';
import fetchApi from '../../../utils/api/fetchApi';
import AntDraggableModal from '../../../utils/extend/AntDraggableModal';
import WebEditUniversal, { WEUExtendPropsType } from '../../system/WebEditUniversalNewEx';
import getList from '../../universal/getList';
import { SocketContext } from '../../../App';

//布局
const layout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 18 },
};

export default function BranchStoreMenuWarehouseSpecEdit(props: any) {

    const [form] = Form.useForm(); //form 
    const { data } = props;
    const ref = useRef<any>(undefined);

    /** 门店菜式数据 */
    const [branchStoreMenuWarehouseData, setBranchStoreMenuWarehouseData] = useState<any>();

    /** 该规格关联的各菜谱数据 */
    const [menuSpecData, setMenuSpecData] = useState<any>([]);

    /** 是否需要创建特殊规格新数据 */
    const [specialData, setSpecialData] = useState<any>(99);

    /** 是否特殊规格 */
    const [specialState, setSpecialState] = useState<any>(true);

    /** 规格名称是否可修改 */
    const [specNameState, setSpecNameState] = useState<any>(false);

    /** 是否需要创建新数据 */
    const [newData, setNewData] = useState<any>(true);

    /** 是否可以改价格 */
    const [priceData, setPriceData] = useState<any>(false);

    /** 菜品智库规格 */
    const [menuWarehouseSpecData, setMenuWarehouseSpecData] = useState<any>([]);

    /** 后端数据wmService */
    let wmService: any = "";

    const useContextData = useContext(SocketContext);
    const { contextData } = useContextData;

    useEffect(() => {
        if (ref.current) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            wmService = ref.current.wmService;
            ref.current.row.then(async (res: any) => {
                if (typeof res === 'undefined') { return }
                if (res.success === true) {
                    setMenuSpecData(res.data.menuSpecs);
                    form.setFieldValue('basePrice', res.data.price);

                    if (res.data.isSpecial) {
                        setSpecialState(true);
                        setPriceData(true);
                    }

                }
            })
        }
        const fetchData = async () => {

            if (!data.sendPageData.menuWarehouseId) {
                setSpecialData(88);
                if (data.type === 'NEW') {
                    setSpecialState(false);
                }
            }

            if (data.type === 'EDIT') {
                setSpecialState(true);
                setSpecNameState(true);
            }

            form.setFieldsValue({ branchStoreId: data.sendPageData.branchStoreId });
            form.setFieldsValue({ branchStoreMenuWarehouseId: data.sendPageData.branchStoreMenuWarehouseId });

            fetchApi.GET(wmService, {
                apiId: 'branchStoreMenuWarehouse',
                apiExtend: 'showMenuList',
                apiData: {
                    // branchStoreId: localStorage.getItem("currentBranchStoreId"),
                    branchStoreId: contextData?.currentBranchStoreId,
                    mountDataOptions: {
                        userMount: {
                            isDept: true
                        }
                    }
                }
            }).then(res => {
                if (res.success) {
                    setBranchStoreMenuWarehouseData(res.data);
                }
            });

            fetchApi.GET(wmService, {
                apiId: 'menuWarehouseSpec',
                apiExtend: 'checkSpec',
                branchStoreMenuWarehouseId: data.sendPageData.branchStoreMenuWarehouseId,
                menuWarehouseId: data.sendPageData.menuWarehouseId
            }).then(res => {
                if (res.success) {
                    setMenuWarehouseSpecData(res.data);
                }
            });

        }
        fetchData()
    }, [])

    const onChangeRadio = (e: any) => {
        // console.log(e.target.value);
        setNewData(!newData)
        let menuWarehouseSpecName: any;
        for (var i_data = 0, len_data = menuWarehouseSpecData.length; i_data < len_data; i_data++) {
            if (menuWarehouseSpecData[i_data].id === e.target.value) {
                menuWarehouseSpecName = menuWarehouseSpecData[i_data].menuWarehouseSpecName;
            }
        }
        if (e.target.value === "999") {
            setSpecialData(0);
            form.setFieldsValue({ branchStoreMenuWarehouseSpecName: "" });
        }
        else {
            form.setFieldsValue({ branchStoreMenuWarehouseSpecName: menuWarehouseSpecName });
            setSpecNameState(true);
        }
    };

    const switchChange = (e: any) => {
        if (e) {
            form.setFieldsValue({ price: 0 });
        }
        setPriceData(e);
    };

    const onChangeSpecial = (e: any) => {
        if (e.target.value === 0) {
            form.setFieldsValue({ price: 0 });
            setPriceData(true);
            form.setFieldsValue({ isSpecial: true });
            setSpecialState(true);
        }
        setSpecialData(e.target.value);
    };

    const handleTrim = (e: any) => {
        form.setFieldsValue({ branchStoreMenuWarehouseSpecName: e.target.value.trim() });
    };

    const handleOk = (e: any) => {
        ref.current.handleOk();
    };

    const handleCancel = (e: any) => {
        ref.current.handleCancel();
    };

    let extendProps: WEUExtendPropsType = {
        ...props,
        form,
        apiId: 'branchStoreMenuWarehouseSpec'
    };

    return (
        <>
            <WebEditUniversal ref={ref} props={extendProps} />
            <AntDraggableModal
                title={(data.type === 'NEW' ? specialData === 99 ? '选择需要添加规格的类型' : newData ? '选择或填写门店菜式规格' : '新增门店菜式规格' : '编辑门店菜式规格')}
                open={true}
                okText='确定'
                cancelText='取消'
                onOk={handleOk}
                onCancel={handleCancel}
                closable={false}
                maskClosable={false}
                width={700}
            >
                <Form
                    {...layout}
                    form={form}
                    initialValues={{ "sortBy": 10 }}
                    name="Edit"
                    onFinish={handleOk}
                    onKeyDown={(e: any) => {
                        if (e.key === 'Enter') {
                            handleOk(e)
                        }
                    }}
                >
                    <Row gutter={[8, 0]}>
                        <Col span={data.type === "NEW" && newData && specialData === 99 ? 24 : 0}>
                            <Row gutter={[8, 0]}>
                                <Col span={24}>
                                    <Form.Item
                                        name="specialId"
                                    >
                                        <Radio.Group onChange={onChangeSpecial}>
                                            <Space direction="vertical">
                                                <Radio
                                                    key={1}
                                                    value={0}
                                                >
                                                    添加特殊规格(如选粉、选汤、选规格、选甜度、选冷热...)
                                                </Radio>
                                                <Radio
                                                    key={0}
                                                    value={1}
                                                >
                                                    添加常规规格(如大份、小份、位、份...)<span style={{ color: "red" }}>【添加到仓库规格里】</span>
                                                </Radio>
                                            </Space>
                                        </Radio.Group>
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Col>
                    </Row>

                    <Row gutter={[8, 0]}>
                        <Col span={data.type === "NEW" && newData && specialData === 1 ? 24 : 0}>
                            <Row gutter={[8, 0]}>
                                <Col span={24}>
                                    <Form.Item
                                        name="menuWarehouseSpecId"
                                    >
                                        <Radio.Group onChange={onChangeRadio}>
                                            <Space direction="vertical">
                                                {
                                                    menuWarehouseSpecData.map((item: any, index: any) => {
                                                        return (
                                                            <>
                                                                <Radio
                                                                    key={item.id}
                                                                    disabled={item.state}
                                                                    value={item.id}
                                                                //onChange={(e) => onChangeRadio(e, item.id)}
                                                                >
                                                                    {item.menuWarehouseSpecName}
                                                                </Radio>
                                                            </>
                                                        )
                                                    })
                                                }
                                                <Radio
                                                    key={999}
                                                    value="999"
                                                >
                                                    列表没有想要的,我需要重新添加
                                                </Radio>
                                            </Space>
                                        </Radio.Group>
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Col>
                    </Row>

                    <Row gutter={[8, 0]}>
                        <Col span={data.type === "EDIT" ? 24 : (newData && (specialData === 99 || specialData === 1)) ? 0 : 24}>
                            <Row gutter={[8, 0]}>
                                <Col span={24}>
                                    <Form.Item
                                        label="id"
                                        name="id">
                                        <Input disabled={true} />
                                    </Form.Item>
                                </Col>

                                <Col span={0}>
                                    <Form.Item
                                        label="门店id"
                                        name="branchStoreId">
                                        <Input disabled={true} />
                                    </Form.Item>
                                </Col>

                                <Col span={0}>
                                    <Form.Item
                                        label="仓库规格id"
                                        name="menuWarehouseSpecId">
                                        <Input disabled={true} />
                                    </Form.Item>
                                </Col>

                                <Col span={form.getFieldValue("isSpecial") ? 0 : menuSpecData.length > 0 ? 24 : 0}>
                                    <Form.Item label="不同菜谱的规格价格" >
                                        {
                                            menuSpecData.map((item: any, index: any) => {
                                                if (menuSpecData.length > 0) {
                                                    if (menuSpecData[index].price === menuSpecData[0].price) {
                                                        return (
                                                            <>
                                                                <Form.Item>
                                                                    <Input disabled style={{ color: "yellow" }} value={'【' + item.menu.menuHead.menuHeadName + '】   ' + item.menu.foodName + "（" + item.menuSpecName + '）' + (item.otherFoodName ? "_ " + item.otherFoodName : "") + '：' + item.price + ' 元'} />
                                                                </Form.Item>
                                                            </>
                                                        )
                                                    }
                                                    else {
                                                        return (
                                                            <>
                                                                <Form.Item>
                                                                    <Input disabled style={{ color: "red", fontWeight: 'bold' }} value={'【' + item.menu.menuHead.menuHeadName + '】   ' + item.menu.foodName + "（" + item.menuSpecName + '）：' + item.price + ' 元'} />
                                                                </Form.Item>
                                                            </>
                                                        )
                                                    }
                                                }
                                            })
                                        }
                                    </Form.Item>
                                </Col>

                                <Col span={24}>
                                    <Form.Item
                                        label={data.sendPageData.foodType === 'setMeal' ? "套餐名称" : "菜式名称"}
                                        name="branchStoreMenuWarehouseId">
                                        <Select
                                            disabled
                                            showSearch
                                            placeholder={data.sendPageData.foodType === 'setMeal' ? "套餐名称" : "菜式名称"}
                                            optionFilterProp="children"
                                            filterOption={(input, option: any) =>
                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                            {getList.general(branchStoreMenuWarehouseData, 'foodName')}
                                        </Select>
                                    </Form.Item>
                                </Col>

                                <Col span={24}>
                                    <Form.Item
                                        label={data.sendPageData.foodType === 'setMeal' ? "规格 / 套餐类别" : "规格"}
                                        name="branchStoreMenuWarehouseSpecName"
                                        rules={[{ required: true, message: data.sendPageData.foodType === 'setMeal' ? "请输入规格 / 套餐类别" : '请输入规格!' }]}>
                                        <Input onChange={handleTrim} disabled={specNameState} />
                                    </Form.Item>
                                </Col>

                                {/* <Col span={0}>
                                    <Form.Item
                                        label="修改前价钱"
                                        name="basePrice"
                                    >
                                        <InputNumber disabled />
                                    </Form.Item>
                                </Col> */}

                                <Col span={24}>
                                    <Form.Item
                                        label="扩展名称"
                                        name="otherFoodName"
                                        tooltip="如需这样显示：杯(450ML)的话，“杯”就是规格，“450ML”就是扩展名称。"
                                    >
                                        <Input placeholder='扩展菜名(当遇另类规格时使用)!' />
                                    </Form.Item>
                                </Col>

                                <Col span={data.sendPageData.foodType === 'tea' ? 24 : 0}>
                                    <Form.Item
                                        label="默认茶位"
                                        name="defaultHeadCount"
                                        rules={[{ required: data.sendPageData.foodType === 'tea' ? true : false, message: '请输入默认茶位!' }]}>
                                        <InputNumber min={1} />
                                    </Form.Item>
                                </Col>

                                <Col span={24}>
                                    <Form.Item
                                        label="基础价"
                                        name="price"
                                        rules={[{ required: true, message: '请输入基础价!' }]}>
                                        <InputNumber disabled={priceData} min={0} />
                                    </Form.Item>
                                </Col>

                                <Col span={24}>
                                    <Form.Item
                                        label="排序"
                                        name="sortBy">
                                        <InputNumber min={1} />
                                    </Form.Item>
                                </Col>

                                <Col span={24}>
                                    <Form.Item
                                        label={data.sendPageData.foodType === 'setMeal' ? "是否套餐类别" : "是否特殊属性"}
                                        name="isSpecial"
                                        valuePropName="checked">
                                        <Switch
                                            disabled={specialState}
                                            onChange={(e) => switchChange(e)}
                                            checkedChildren="是"
                                            unCheckedChildren="否" />
                                    </Form.Item>
                                </Col>

                                <Col span={24}>
                                    <Form.Item
                                        label="修改菜谱内容"
                                        name="isMandatory"
                                        tooltip="强制把其他菜谱里与之相同规格进行价格和扩展名进行修改。"
                                        valuePropName="checked"
                                        initialValue={true}>
                                        <Switch checked={true}
                                            checkedChildren="强制修改"
                                            unCheckedChildren="不强制修改" />
                                    </Form.Item>
                                </Col>

                                <Col span={24}>
                                    <Form.Item
                                        label="状态"
                                        name="isUse"
                                        valuePropName="checked"
                                        initialValue={true}>
                                        <Switch checked={true}
                                            checkedChildren="启用"
                                            unCheckedChildren="关闭" />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Form>
            </AntDraggableModal>
        </>
    )
}